// Central project types
export const CENTRAL_PROJECT_TYPES = {
  DONER: 'doner',
  NEC: 'nec'
};

// Installment release types
export const INSTALLMENT_RELEASE_TYPES = {
  CENTRAL_DONER: 'central_doner',    // DoNER releases for DoNER projects
  CENTRAL_NEC: 'central_nec',        // NEC releases for NEC projects  
  STATE: 'state'                     // State releases for both DoNER and NEC projects
};

// DoNER Schemes
export const DONER_SCHEMES = [
  { value: 'nesids-otri', label: 'NESIDS (OTRI)' },
  { value: 'pm-devine', label: 'PM-DevINE' }
];

// NEC Schemes
export const NEC_SCHEMES = [
  { value: 'schemes-of-nec-sonec', label: 'Schemes of NEC (SONEC)' },
  { value: 'nesids-roads', label: 'NESIDS Roads' },
  { value: 'focus-development-component', label: 'Focus Development Component' }
];

// Validation limits for central projects (in lakhs)
export const CENTRAL_VALIDATION_LIMITS = {
  PROJECT_NAME_MIN_LENGTH: 3,
  PROJECT_NAME_MAX_LENGTH: 200,
  AMOUNT_MIN: 0.01,
  AMOUNT_MAX: 99999,
  WORK_ORDER_NUMBER_MIN_LENGTH: 1,
  WORK_ORDER_NUMBER_MAX_LENGTH: 50
};

// UPDATED: Installment validation limits - removed amount released by validation
export const INSTALLMENT_VALIDATION_LIMITS = {
  INSTALLMENT_NUMBER_MIN: 1,
  INSTALLMENT_NUMBER_MAX: 50,
  AMOUNT_MIN: 0.01,
  AMOUNT_MAX: 99999,
  PHYSICAL_PROGRESS_MIN: 0,
  PHYSICAL_PROGRESS_MAX: 100
  // REMOVED: RELEASED_BY_MIN_LENGTH and RELEASED_BY_MAX_LENGTH
};

// Installment number options
export const INSTALLMENT_NUMBER_OPTIONS = [
  { value: '1', label: '1st Installment' },
  { value: '2', label: '2nd Installment' },
  { value: '3', label: '3rd Installment' },
  { value: '4', label: '4th Installment' },
  { value: '5', label: '5th Installment' },
  { value: '6', label: '6th Installment' },
  { value: '7', label: '7th Installment' },
  { value: '8', label: '8th Installment' },
  { value: '9', label: '9th Installment' },
  { value: '10', label: '10th Installment' }
];

// UC validation limits
export const UC_VALIDATION_LIMITS = {
  UC_NUMBER_MIN_LENGTH: 3,
  UC_NUMBER_MAX_LENGTH: 50
};

// Default central project data structure - with work order fields
export const DEFAULT_CENTRAL_PROJECT_DATA = {
  projectName: '',
  scheme: '',
  centralShare: '', // DoNER/NEC Share
  stateShare: '',
  totalAmount: 0,
  financialYear: '',
  type: '', // DONER or NEC
  status: 'pending',
  workOrderNumber: '',
  workOrderIssueDate: '',
  scheduledCompletionDate: '',
  createdAt: null,
  updatedAt: null,
  createdBy: null
};

// UPDATED: Default installment data structure - removed amountReleasedBy field
export const DEFAULT_INSTALLMENT_DATA = {
  financialYear: '',
  projectId: '',
  projectName: '',
  projectType: '', // DONER, NEC (the original project type)
  releaseType: '', // CENTRAL_DONER, CENTRAL_NEC, STATE (who is releasing the installment)
  installmentNumber: '',
  releaseDate: '',
  amount: '',
  physicalProgress: '',
  createdAt: null,
  updatedAt: null,
  createdBy: null
  // REMOVED: amountReleasedBy field
};

// Default UC data structure
export const DEFAULT_UC_DATA = {
  financialYear: '',
  projectId: '',
  projectName: '',
  projectType: '', // DONER, NEC
  centralShare: 0, // Auto-populated from project data
  ucNumber: '',
  ucCertificateDate: '', // UC certificate date
  ucFurnished: '', // Amount field
  ucDue: '', // Amount field
  createdAt: null,
  updatedAt: null,
  createdBy: null
};

// Get schemes by project type
export const getSchemesByType = (type) => {
  switch (type) {
    case CENTRAL_PROJECT_TYPES.DONER:
      return DONER_SCHEMES;
    case CENTRAL_PROJECT_TYPES.NEC:
      return NEC_SCHEMES;
    default:
      return [];
  }
};

// Get project type label
export const getProjectTypeLabel = (type) => {
  const labels = {
    [CENTRAL_PROJECT_TYPES.DONER]: 'DoNER',
    [CENTRAL_PROJECT_TYPES.NEC]: 'NEC'
  };
  return labels[type] || type;
};

// Get release type label
export const getReleaseTypeLabel = (releaseType) => {
  const labels = {
    [INSTALLMENT_RELEASE_TYPES.CENTRAL_DONER]: 'DoNER Central',
    [INSTALLMENT_RELEASE_TYPES.CENTRAL_NEC]: 'NEC Central',
    [INSTALLMENT_RELEASE_TYPES.STATE]: 'State'
  };
  return labels[releaseType] || releaseType;
};